module.exports = __webpack_public_path__ + "img/user.990faf80.png";